"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _apartment = require("@/api/apartment.api");
var _apartment2 = require("@/types/apartment");
var _building = require("@/api/building.api");
var _buildingSevice = require("@/api/building-sevice.api");
var _ApartmentCustomer = _interopRequireDefault(require("./ApartmentCustomer.vue"));
var _ApartmentInvoice = _interopRequireDefault(require("./ApartmentInvoice.vue"));
var rule = {
  required: true,
  message: "Bắt buộc",
  trigger: "submit"
};
var ApartmentModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ApartmentModal, _Vue);
  var _super = (0, _createSuper2.default)(ApartmentModal);
  function ApartmentModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ApartmentModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogWidth", "700px");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {
      code: rule,
      buildingId: rule
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingServices", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildings", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ApartmentStatus", _apartment2.ApartmentStatus);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ApartmentStatusTrans", _apartment2.ApartmentStatusTrans);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingDelete", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tab", "info");
    return _this;
  }
  (0, _createClass2.default)(ApartmentModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$confirm("Xác nhận xóa căn phòng/hộ này?", "Cảnh báo", {
                  cancelButtonText: "Không",
                  confirmButtonText: "Có",
                  type: "warning"
                });
              case 2:
                this.loadingDelete = true;
                _context.prev = 3;
                _context.next = 6;
                return _apartment.apartmentApi.delete(this.form.id);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Xóa thành công",
                  type: "success"
                });
                this.onSubmitOk();
                this.visible = false;
              case 9:
                _context.prev = 9;
                this.loadingDelete = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleChangeTab",
    value: function handleChangeTab() {
      switch (this.tab) {
        case "invoice":
          this.dialogWidth = "1200px";
          break;
        default:
          this.dialogWidth = "700px";
          break;
      }
    }
  }, {
    key: "handleUpdateCustomer",
    value: function handleUpdateCustomer(customer) {
      this.form.customer = customer;
      this.onSubmitOk();
    }
  }, {
    key: "fetchBuildingServices",
    value: function () {
      var _fetchBuildingServices = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _buildingSevice.buildingServiceApi.findAll({
                  buildingId: this.form.buildingId || this.buildingId,
                  isActive: true
                });
              case 2:
                res = _context2.sent;
                this.buildingServices = res.data;
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function fetchBuildingServices() {
        return _fetchBuildingServices.apply(this, arguments);
      }
      return fetchBuildingServices;
    }()
  }, {
    key: "fetchBuildings",
    value: function () {
      var _fetchBuildings = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(search) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _building.buildingApi.findAll({
                  page: 1,
                  limit: 0,
                  search: search
                });
              case 2:
                res = _context3.sent;
                this.buildings = res.data.buildings;
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function fetchBuildings(_x) {
        return _fetchBuildings.apply(this, arguments);
      }
      return fetchBuildings;
    }()
  }, {
    key: "dataSubmit",
    get: function get() {
      return {
        apartment: {
          code: this.form.code,
          area: this.form.area
        },
        buildingId: this.form.buildingId || this.buildingId,
        buildingServiceIds: this.form.buildingServiceIds
      };
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context4.prev = 3;
                _context4.next = 6;
                return _apartment.apartmentApi.create(this.dataSubmit);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Tạo mới thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context4.prev = 9;
                this.loading = false;
                return _context4.finish(9);
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3,, 9, 12]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context5.prev = 3;
                _context5.next = 6;
                return _apartment.apartmentApi.update(this.form.id, this.dataSubmit);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Cập nhật thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context5.prev = 9;
                this.loading = false;
                return _context5.finish(9);
              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[3,, 9, 12]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.dialogWidth = "700px";
      this.tab = "info";
      this.form = {};
      this.fetchBuildings();
      this.fetchBuildingServices();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        buildingId: data.building && data.building.id
        // apartment: data.buildingServices.map((e) => e.id),
      });

      this.dialogWidth = "700px";
      this.visible = true;
      this.tab = "info";
      this.status = "update";
      this.fetchBuildings();
      this.fetchBuildingServices();
    }
  }]);
  return ApartmentModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: false
})], ApartmentModal.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], ApartmentModal.prototype, "onSubmitOk", null);
ApartmentModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ApartmentCustomer: _ApartmentCustomer.default,
    ApartmentInvoice: _ApartmentInvoice.default
  }
})], ApartmentModal);
var _default = ApartmentModal;
exports.default = _default;